export default __webpack_public_path__ + "static/media/new-arrow-dropDown.3b69fb32.svg";